export default "__VITE_ASSET__w78LV4nE__"